import { Timestamp } from "@firebase/firestore";

/**
 * Firestore notices 컬렉션의 Notice 문서 인터페이스
 */
export interface Board {
  boardId: string;
  title: string;
  content: string | null; // HTML 내용이 포함될 수 있으므로 string 타입으로 정의
  isPublic: boolean;
  allowedUsers: string[] | null; // isPublic이 false일 때만 사용
  allowedEnterprises: string[] | null; // isPublic이 false일 때만 사용
  createdAt: Timestamp;
}

/**
 * Board 컬렉션 경로 상수
 */
export const BOARD_COLLECTION = process.env.REACT_APP_BOARD_COLLECTION as string;